var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seviceErr"
  }, [_c('im-top'), _vm._v(" "), (_vm.errType === 'costomerErr') ? _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_sorry.png',
      "alt": "无客服"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errType === 'serviceErr') ? _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_err.png',
      "alt": "服务器忙"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errType === 'costomerErr') ? _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.msgService)
    }
  }) : _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.msgErr))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a01152a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/serviceError.vue
// module id = 6Qys
// module chunks = 1